import { useLang } from "@/lib/i18n";
import { COUNTRIES, COUNTRIES_FR } from "@/lib/format";
import { Reveal, Stagger, StaggerItem } from "@/components/site/Motion";

const HUBS = [
  { name: "London", x: 27, y: 26 }, { name: "Amsterdam", x: 37, y: 22 }, { name: "Brussels", x: 35, y: 30 },
  { name: "Paris", x: 31, y: 40, main: true }, { name: "Geneva", x: 39, y: 52 }, { name: "Munich", x: 50, y: 44 },
  { name: "Milan", x: 45, y: 60 }, { name: "Monaco", x: 41, y: 66 }, { name: "Madrid", x: 17, y: 74 }, { name: "Dubai", x: 92, y: 86 },
];

export const NetworkSection = () => {
  const { t, lang } = useLang();
  const paris = HUBS.find((h) => h.main);
  return (
    <section className="section relative overflow-hidden bg-[#070809]" data-testid="network-section">
      <div className="container-x grid gap-14 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <h2 className="display text-3xl sm:text-4xl lg:text-5xl">
            {t("network_title_1")}<br /><span className="text-[#8b95a5]">{t("network_title_2")}</span>
          </h2>
          <p className="mt-8 max-w-md text-base leading-relaxed text-[#c7ccd4]">{t("network_copy")}</p>
          <Stagger className="mt-12 grid grid-cols-2 gap-x-8">
            {COUNTRIES.map((c) => (
              <StaggerItem key={c} className="mono border-t border-white/10 py-3 text-[0.62rem] text-[#dfe3e8]">
                {lang === "fr" ? COUNTRIES_FR[c] : c}
              </StaggerItem>
            ))}
          </Stagger>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-7">
          <div className="relative aspect-[4/3] w-full overflow-hidden border border-white/10 bg-[#0b0d10] sm:aspect-[16/10]" data-testid="network-map">
            <div className="absolute inset-0 opacity-40" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,.14) 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
            <svg viewBox="0 0 100 75" className="absolute inset-0 h-full w-full" preserveAspectRatio="none">
              {HUBS.filter((h) => !h.main).map((h) => {
                const cx = (paris.x + h.x) / 2, cy = Math.min(paris.y, h.y) * 0.75 - 4;
                const d = `M ${paris.x} ${paris.y * 0.75} Q ${cx} ${cy} ${h.x} ${h.y * 0.75}`;
                return (
                  <path key={h.name} d={d} fill="none" stroke="rgba(226,200,157,.45)" strokeWidth="0.25" strokeDasharray="200" strokeDashoffset="200"
                        style={{ animation: "dash 2.8s ease-out forwards", animationDelay: `${Math.random() * 0.8 + 0.3}s` }} />
                );
              })}
            </svg>
            {HUBS.map((h) => (
              <div key={h.name} className="absolute" style={{ left: `${h.x}%`, top: `${h.y}%`, transform: "translate(-50%,-50%)" }}>
                <span className="relative block">
                  <span className={`absolute inset-0 rounded-full ${h.main ? "bg-[#e2c89d]" : "bg-white"} hub-pulse`} style={{ width: h.main ? 10 : 7, height: h.main ? 10 : 7 }} />
                  <span className={`block rounded-full ${h.main ? "bg-[#e2c89d]" : "bg-white"}`} style={{ width: h.main ? 10 : 7, height: h.main ? 10 : 7 }} />
                </span>
                <span className="mono absolute left-4 top-1/2 -translate-y-1/2 whitespace-nowrap text-[0.55rem] text-[#c7ccd4]">{h.name}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
